import { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './ResetPassword.module.css';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { useLocation } from 'react-router';
import { useUpdatePwdMutation } from '../../../services/api';
import { ResetPwdFormData } from '../../../types/login';

import Complete from '../Complete';
import {
  CHANGE,
  COMPLETE,
  CONFIRM_NEW_PASSWORD,
  ENTER,
  ENTER_PASSWORD,
  FIND,
  NEW_PASSWORD,
  NOT_MATCH_PWD,
  PASSWORD,
  PWD_VALIDATION_MSG,
} from '../../../constants';
import { regExPwd } from '../../../utils/util';
import { setLocalStorage } from '../../../utils/storage';

export default function ResetPassword() {
  const cx = classNames.bind(styles);
  const location = useLocation();
  const { email } = location.state;

  const resetPasswordSchema = yup.object({
    email: yup.string().required(),
    pwd: yup.string().matches(regExPwd, {
      message: PWD_VALIDATION_MSG,
    }),
    'confirm-password': yup.string().oneOf([yup.ref('pwd')]),
  });

  const {
    register,
    formState: { errors, isValid, touchedFields },
    handleSubmit,
    getValues,
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(resetPasswordSchema),
    defaultValues: { email, pwd: '', 'confirm-password': '' },
  });

  const [isComplete, setIsComplete] = useState(false);
  const [updatePwd] = useUpdatePwdMutation();

  const onSubmit = async (data: any) => {
    const formData = { ...data };
    console.log('onSubmit', formData);
    delete formData['confirm-password'];

    try {
      const res = await updatePwd(formData).unwrap();
      console.log('res : ', res);
      setIsComplete(res.success);
      setLocalStorage('loggedIn', 0);
    } catch (error) {
      console.log('Failed to update password', error);
    }
  };

  return (
    <>
      <h2>{`${PASSWORD} ${
        !isComplete ? FIND : CHANGE + ' ' + COMPLETE + '!'
      }`}</h2>
      <div>
        {!isComplete ? (
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={cx('input_area')}>
              <div
                className={cx('input_box', {
                  'input--done': getValues('pwd') && !errors['pwd'],
                })}
              >
                <span className={cx('blind')}>
                  `${PASSWORD} ${ENTER}`
                </span>
                <input
                  type="password"
                  title={ENTER_PASSWORD}
                  placeholder={NEW_PASSWORD}
                  autoComplete="new-password"
                  {...register('pwd')}
                />
                {errors['pwd'] && (
                  <span className={cx('msg', 'invalid')}>
                    {errors['pwd'].message}
                  </span>
                )}
              </div>

              <div
                className={cx('input_box', {
                  'input--done': isValid,
                })}
              >
                <span className={cx('blind')}>
                  `${PASSWORD} ${ENTER}`
                </span>
                <input
                  type="password"
                  title={CONFIRM_NEW_PASSWORD}
                  placeholder={CONFIRM_NEW_PASSWORD}
                  autoComplete="new-password"
                  {...register('confirm-password')}
                />
                {errors['confirm-password'] && (
                  <span className={cx('msg', 'invalid')}>{NOT_MATCH_PWD}</span>
                )}
              </div>
            </div>
            <div className={cx('btn_wrap', 'bottom')}>
              <button
                type="submit"
                className={cx('btn', 'b_t', 's48', {
                  'is--disabled': !isValid,
                })}
              >
                <span>{COMPLETE}</span>
              </button>
            </div>
          </form>
        ) : (
          <Complete name="resetPassword" />
        )}
      </div>
    </>
  );
}
